import { render } from "./product-create.vue?vue&type=template&id=a05a6dc4"
import script from "./product-create.vue?vue&type=script&lang=js"
export * from "./product-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__